var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.modules && !!_vm.modules['booking_notifications'])?_c('router-link',{staticClass:"btn btn-link ml-auto",attrs:{"to":"/app/bookings/messaging"}},[_c('fa-icon',{attrs:{"icon":"envelope"}}),_vm._v(" Messageing ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }